import React from 'react'
import {
    FaFacebook,
    FaInstagram,
    FaWhatsapp,
    FaTwitter
} from 'react-icons/fa';
import {
    FooterContainer,
    FooterWrap,
    SocialMedia,
    SocialMediaWrap,
    SocialLogo,
    SocialIcons,
    SocialIconLink
} from './FooterElements';


const Footer = () => {
    return (
     <FooterContainer>
         <FooterWrap>
             <SocialMedia>
                 <SocialMediaWrap>
                     <SocialLogo to="/">TheKitchen</SocialLogo>
                    <SocialIcons>
                        <SocialIconLink href="/" target="_blank" aria-label="Facebook" rel="noopenner noreferrer">
                            <FaFacebook />
                        </SocialIconLink>

                        <SocialIconLink href="/" target="_blank" aria-label="Instagram" rel="noopenner noreferrer">
                            <FaInstagram />
                        </SocialIconLink>

                        <SocialIconLink href="www.twitter.com/badniggafela" target="_blank" aria-label="Twitter">
                            <FaTwitter />
                        </SocialIconLink>

                        <SocialIconLink href="https://wa.me/08161815529" target="_blank" aria-label="Whatsapp">
                            <FaWhatsapp />
                        </SocialIconLink>


                    </SocialIcons>
                 </SocialMediaWrap>
             </SocialMedia>
         </FooterWrap>
     </FooterContainer>
    )
}

export default Footer
